import { z } from 'zod';
import { UlidSchema, IsoTimestampSchema } from './common.js';
import { VisitaTipoSchema } from './visita.js';

export const VisitorPassStatusSchema = z.enum(['pending', 'used', 'expired']);
export type VisitorPassStatus = z.infer<typeof VisitorPassStatusSchema>;

export const VisitorPassSchema = z.object({
  id: UlidSchema,
  tenantId: z.string(),
  unidadId: UlidSchema,
  createdByUserId: z.string(),
  createdByNombre: z.string(),
  unidadNumero: z.string(),
  visitorNombre: z.string().min(2).max(200),
  visitorDni: z.string().min(5).max(20),
  vehiclePatent: z.string().max(10).optional(),
  status: VisitorPassStatusSchema,
  verificationToken: z.string().length(36),
  usedAt: IsoTimestampSchema.nullable(),
  createdAt: IsoTimestampSchema,
  expiresAt: IsoTimestampSchema,
});
export type VisitorPass = z.infer<typeof VisitorPassSchema>;

export const CreateVisitorPassRequestSchema = z.object({
  visitorNombre: z.string().min(2).max(200),
  visitorDni: z.string().min(5).max(20),
  vehiclePatent: z.string().max(10).optional(),
  unidadId: UlidSchema,
});
export type CreateVisitorPassRequest = z.infer<typeof CreateVisitorPassRequestSchema>;

/** What the public verification page sees — no internal IDs. */
export const VisitorPassPublicViewSchema = z.object({
  visitorNombre: z.string(),
  visitorDni: z.string(),
  vehiclePatent: z.string().optional(),
  unidadNumero: z.string(),
  createdByNombre: z.string(),
  status: VisitorPassStatusSchema,
  usedAt: IsoTimestampSchema.nullable(),
  createdAt: IsoTimestampSchema,
  expiresAt: IsoTimestampSchema,
});
export type VisitorPassPublicView = z.infer<typeof VisitorPassPublicViewSchema>;

export const MarkPassUsedRequestSchema = z.object({
  pin: z.string().length(4).regex(/^\d{4}$/, 'PIN debe ser 4 dígitos'),
  tipo: VisitaTipoSchema.optional(),
});
export type MarkPassUsedRequest = z.infer<typeof MarkPassUsedRequestSchema>;
